export const Logo = ({ size = 32, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-label="KuroPulse">
    <polygon points="32,4 58,18 58,46 32,60 6,46 6,18" stroke="#FF2A55" strokeWidth="3" fill="#0F0D16" />
    <polyline points="12,34 22,34 27,22 33,44 38,28 42,34 52,34" stroke="#00F0FF" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <circle cx="32" cy="34" r="2.5" fill="#FF2A55" />
  </svg>
);
